let zoomImages = [];

;(function ($) {
  "use strict";

  $(document).ready(function () {
    const zoomButtons = $('figure .zoom-toggle');

    // build object of images and captions
    zoomButtons.each(function () {
      const figure = $(this).closest('figure');
      const src = figure.find('img').first().attr('src');
      const caption = figure.find('figcaption').text();

      zoomImages.push({src: src, caption: caption});
    });
  });
})(jQuery);

export function initImageZoom(imgSrc) {
  const $zoomModal = $('#zoom-modal .image-zoom__wrapper');
  const imageData = zoomImages.find(img => img.src === imgSrc);

  // Clear existing image and caption from within the modal
  $zoomModal.empty();

  // Mount new image and caption
  $('<img />').attr({src: imgSrc, alt: imageData.caption}).appendTo($zoomModal);
  if(imageData.caption) {
    $('<div class="image-zoom__caption" />').text(imageData.caption).appendTo($zoomModal);
  }
}
